// @flow
import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import icons from '../../../../assets/styles/icons.scss';
import { Desktop } from '../../../../utils/responsive';
import Drawer from '../../../../elements/Drawer/Drawer';
import Responsive from 'react-responsive';

import style from './LoggedMenu.scss';
import avatarStyle from '../../../../assets/styles/avatar.scss';
import navbarStyle from '../Navbar.scss';
import defaultPic from '../../../../assets/img/profileplaceholder.jpg';

import type { User } from '../../../../entities/user';
import type { LocaleState } from '../../../locale/duck';

type Props = {
  +open: boolean;
  +logout: () => void;
  +user: User;
  +close: () => void;
  +locale: LocaleState;
};

export default class LoggedMenu extends Component<Props, void> {
  handleClickOutside(e: Event) {
    const { close } = this.props;
    const wrap = document.querySelector(`.${style.loggedMenuWrap}`);
    const mainWrap = document.querySelector(`.${navbarStyle.loggedOptionsWrap}`);
    if (wrap && mainWrap && e.target instanceof Node) {
      const target = e.target;
      if (!mainWrap.contains(target) && !wrap.contains(target)) {
        close();
      }
    }
  }

  handleLogOut(e: Event) {
    e.preventDefault();
    const { logout, close } = this.props;
    logout();
    close();
  }

  /*componentWillReceiveProps(nextProps: Props) {
    if (nextProps.open && document) {
      document.addEventListener('click', this.handleClickOutside.bind(this));
    } else if (document) {
      document.removeEventListener('click', this.handleClickOutside.bind(this));
    }
  }*/

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    // Ensure to remove listener if loggedout with menu open
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  render() {
    const { open, user, close, locale } = this.props;
    const responsiveMenu = open && [
      <Helmet key="helmet">
        <style type="text/css">{`
          body {
              overflow: hidden!important;
          }
      `}</style>
      </Helmet>,
      <section key="loggedResponsiveMenu" className={style.loggedResponsiveMenuWrap}>
        {/*<article className={style.userWrap}>
          <img src={user.image || defaultPic}
               alt={user.firstName}
               className={classNames(avatarStyle.avatar, avatarStyle.medium, style.avatar)}/>
          <span className={style.username}>{user.firstName} {user.lastName}</span>
        </article>*/}
        <ul>
          <li className={style.noBorder}><FormattedMessage id="nav.loggedMenu.settings">{
            txt => <Link onClick={close} to="/preferences"
                         className={style.myAccount}>
              <img src={user.image || defaultPic}
                   className={classNames(avatarStyle.avatar, style.avatar)}
                   alt={`${user.firstName} ${user.lastName}`}/>
              {txt}
            </Link>
          }</FormattedMessage></li>
          {/*<li><FormattedMessage id="nav.loggedMenu.buyer.label">{
            txt => <p className={style.subtitle}>{txt}</p>
          }</FormattedMessage></li>*/}

          <li className={style.buy}><FormattedMessage id="nav.buyBig">{
            txt => <Link onClick={close} to="/">
              {txt}{/*<i className={icons.iconBagMedium}/>*/}</Link>
          }</FormattedMessage></li>
          <li><FormattedMessage id="nav.loggedMenu.myOrders">{
            txt => <Link onClick={close} to="/orders/active">
              {txt}{/*<i className={icons.iconBoxEmptyMedium}/>*/}</Link>
          }</FormattedMessage></li>
          <li><FormattedMessage id="nav.travelBig">{
            txt => <Link onClick={close} to="/orders/active">
              {txt}</Link>
          }</FormattedMessage></li>
          <li className={style.createFlight}><FormattedMessage id={locale.domainCountry === 'CO' ? 'nav.earn.CO' : 'nav.earn'}>{
            txt => <Link onClick={close} to="/preferences/referral">
              {txt}{/*<i className={icons.iconAirplaneMedium}/>*/}</Link>
          }</FormattedMessage></li>
          <li><FormattedMessage id="nav.loggedMenu.myFlights">{
            txt => <Link onClick={close} to="/flights">
              {txt}{/*<i className={icons.iconSuitcaseMedium}/>*/}</Link>
          }</FormattedMessage></li>

          {/*<li><FormattedMessage id="nav.loggedMenu.general.label">{
            txt => <p className={style.subtitle}>{txt}</p>
          }</FormattedMessage></li>*/}
          <li><FormattedMessage id="nav.loggedMenu.paymentHistory">{
            txt => <Link onClick={close} to="/my-payments">
              {txt}{/*<i className={icons.iconVoucherMedium}/>*/}</Link>
          }</FormattedMessage></li>
          <li><FormattedMessage id="nav.loggedMenu.myWishLists">{
            txt => <Link onClick={close} to="/my-wish-lists">
              {txt}</Link>
          }</FormattedMessage></li>
          <li className={style.help}><FormattedMessage id="nav.loggedMenu.help">{
            txt => <a onClick={close}
                      href="https://help.qempo.com/"
                      target="_blank">
              {txt}{/*<i className={icons.symbolQuestionCircle}/>*/}</a>
          }</FormattedMessage></li>
          <li><FormattedMessage id="nav.loggedMenu.referral">{
            txt => <Link onClick={close} to="/preferences/referral">
              {txt}</Link>
          }</FormattedMessage></li>
          <li>
            <FormattedMessage id="nav.loggedMenu.logOut">{
              txt => <a className={style.logout}
                        onClick={this.handleLogOut.bind(this)}
                        href="#">{txt}{/*<i className={icons.symbolLogOut}/>*/}</a>
            }</FormattedMessage>
          </li>
        </ul>

      </section>
    ];
    return <Fragment>
      <Desktop>
        <aside className={classNames(style.loggedMenuWrap, { [style.open]: open })}>
          <section className={style.loggedMenuContent}>
            <ul>
              {/*<li><FormattedMessage id="nav.loggedMenu.buyer.label">{
                txt => <p className={style.subtitle}>{txt}</p>
              }</FormattedMessage></li>*/}
              <li><FormattedMessage id="nav.loggedMenu.settings">{
                txt => <Link onClick={close} to="/preferences"
                             className={style.myAccount}>
                  <img src={user.image || defaultPic}
                       className={classNames(avatarStyle.avatar, style.avatar)}
                       alt={`${user.firstName} ${user.lastName}`}/>
                  {txt}
                  {/*<i className={icons.symbolSettings}/>*/}
                </Link>
              }</FormattedMessage></li>
              <li className={style.buy}><FormattedMessage id="nav.buyBig">{
                txt => <Link onClick={close} to="/">
                  {txt}{/*<i className={icons.iconBagLight}/>*/}</Link>
              }</FormattedMessage></li>
              <li className={style.createFlight}><FormattedMessage id="nav.loggedMenu.myOrders">{
                txt => <Link onClick={close} to="/orders/active">
                  {txt}{/*<i className={icons.iconBoxEmptyLight}/>*/}</Link>
              }</FormattedMessage></li>
              {/*<li><FormattedMessage id="nav.loggedMenu.traveler.label">{
                txt => <p className={style.subtitle}>{txt}</p>
              }</FormattedMessage></li>*/}
              <li><FormattedMessage id="nav.travelBig">{
                txt => <Link onClick={close} to="/new-flight"
                             className={style.createFlight}>
                  {txt}{/*<i className={icons.iconAirplaneLight}/>*/}</Link>
              }</FormattedMessage></li>
              <li><FormattedMessage id="nav.loggedMenu.myFlights">{
                txt => <Link onClick={close} to="/flights">
                  {txt}{/*<i className={icons.iconSuitcaseLight}/>*/}</Link>
              }</FormattedMessage></li>
              {/*<li><FormattedMessage id="nav.loggedMenu.general.label">{
                txt => <p className={style.subtitle}>{txt}</p>
              }</FormattedMessage></li>*/}
              <li><FormattedMessage id="nav.loggedMenu.paymentHistory">{
                txt => <Link onClick={close} to="/my-payments">
                  {txt}{/*<i className={icons.iconInvoiceLight}/>*/}</Link>
              }</FormattedMessage></li>
              <li><FormattedMessage id="nav.loggedMenu.myWishLists">{
                txt => <Link onClick={close} to="/my-wish-lists">
                  {txt}</Link>
              }</FormattedMessage></li>
              <li><FormattedMessage id="nav.loggedMenu.referral">{
                txt => <Link onClick={close} to="/preferences/referral">
                  {txt}</Link>
              }</FormattedMessage></li>
              <li className={style.help}><FormattedMessage id="nav.loggedMenu.help">{
                txt => <a onClick={close}
                          className={style.faqLabel}
                          href="https://help.qempo.com/"
                          target="_blank">
                  {txt}{/*<i className={icons.symbolQuestionCircle}/>*/}</a>
              }</FormattedMessage></li>
              <li>
                <a className={style.logout}
                   href="#"
                   onClick={this.handleLogOut.bind(this)}>
                  <FormattedMessage id="nav.loggedMenu.logOut"/>
                  {/*<i className={icons.symbolLogOut}/>*/}
                </a>
              </li>
            </ul>
          </section>
        </aside>
      </Desktop>
      <Responsive maxWidth={991}>
        <Drawer open={open}
                handleClickOutside={close}>
          {responsiveMenu}
        </Drawer>
      </Responsive>
    </Fragment>;
  }
}

LoggedMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/navbar/components/logged-menu/LoggedMenu.jsx